<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6.35 6.35"><path fill-rule="evenodd" d="M3.18.26a2.92 2.92 0 1 0 0 5.85 2.92 2.92 0 0 0 0-5.85m0 .53a2.38 2.38 0 1 1 0 4.78 2.38 2.38 0 1 1 0-4.78m0 1.06a.27.27 0 0 0-.27.27v.8H2.1a.27.27 0 0 0 .03.53h.8v.79a.27.27 0 0 0 .53 0v-.8h.79a.27.27 0 0 0 0-.52h-.8v-.8a.3.3 0 0 0-.26-.27" paint-order="stroke fill markers"/></svg>
</template>
